var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateContract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract (2)",
    clipPath: "url(#clip0_5952_14512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5614 5.34992C15.9789 4.76734 15.031 4.76737 14.4482 5.35005C14.269 5.52945 13.1246 6.67472 12.9498 6.8497V2.90282C12.9498 2.50372 12.7944 2.12852 12.5122 1.84633L11.1035 0.437617C10.8213 0.155391 10.4461 0 10.047 0H1.49475C0.670882 0 0.000610352 0.670272 0.000610352 1.49414V15.5059C0.000610352 16.3297 0.670882 17 1.49475 17H11.4557C12.2796 17 12.9498 16.3297 12.9498 15.5059V11.0776L16.5614 7.46297C17.1453 6.87906 17.1455 5.9339 16.5614 5.34992ZM9.96158 0.996094C10.0557 0.996094 10.237 0.979791 10.3992 1.14196L11.8079 2.55066C11.9659 2.70874 11.9538 2.88196 11.9538 2.98828H9.96158V0.996094ZM11.9537 15.5059C11.9537 15.7805 11.7303 16.0039 11.4557 16.0039H1.49475C1.22013 16.0039 0.996704 15.7805 0.996704 15.5059V1.49414C0.996704 1.21952 1.22013 0.996094 1.49475 0.996094H8.96545V3.48633C8.96545 3.76138 9.18845 3.98438 9.4635 3.98438H11.9537V7.84666L10.4843 9.31733L9.78029 10.0214C9.72564 10.076 9.6844 10.1427 9.65996 10.216L8.95559 12.3291C8.89593 12.508 8.94251 12.7054 9.07592 12.8388C9.20949 12.9723 9.40689 13.0187 9.58559 12.9591L11.6986 12.2547C11.772 12.2303 11.8387 12.1891 11.8933 12.1344L11.9537 12.074V15.5059ZM10.8368 10.3736L11.5411 11.0779L11.2721 11.3469L10.2156 11.6991L10.5677 10.6426L10.8368 10.3736ZM12.2453 10.3734L11.541 9.66905C11.916 9.29369 13.5818 7.62649 13.9351 7.27291L14.6394 7.97725L12.2453 10.3734ZM15.8569 6.75876L15.3435 7.27261L14.6392 6.56828L15.1528 6.05426C15.3471 5.86005 15.663 5.86009 15.8571 6.05426C16.0513 6.2485 16.0523 6.56336 15.8569 6.75876Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.4635 4.98047H2.49084C2.21579 4.98047 1.9928 5.20346 1.9928 5.47852C1.9928 5.75357 2.21579 5.97656 2.49084 5.97656H9.4635C9.73855 5.97656 9.96154 5.75357 9.96154 5.47852C9.96154 5.20346 9.73855 4.98047 9.4635 4.98047Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.47131 6.97266H2.49084C2.21579 6.97266 1.9928 7.19565 1.9928 7.4707C1.9928 7.74576 2.21579 7.96875 2.49084 7.96875H7.47131C7.74637 7.96875 7.96936 7.74576 7.96936 7.4707C7.96936 7.19565 7.74637 6.97266 7.47131 6.97266Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.47131 8.96484H2.49084C2.21579 8.96484 1.9928 9.18784 1.9928 9.46289C1.9928 9.73795 2.21579 9.96094 2.49084 9.96094H7.47131C7.74637 9.96094 7.96936 9.73795 7.96936 9.46289C7.96936 9.18784 7.74637 8.96484 7.47131 8.96484Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.47131 10.957H2.49084C2.21579 10.957 1.9928 11.18 1.9928 11.4551C1.9928 11.7301 2.21579 11.9531 2.49084 11.9531H7.47131C7.74637 11.9531 7.96936 11.7301 7.96936 11.4551C7.96936 11.18 7.74637 10.957 7.47131 10.957Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.4635 14.0117H6.47522C6.20017 14.0117 5.97717 14.2347 5.97717 14.5098C5.97717 14.7848 6.20017 15.0078 6.47522 15.0078H9.4635C9.73856 15.0078 9.96155 14.7848 9.96155 14.5098C9.96155 14.2347 9.73856 14.0117 9.4635 14.0117Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5952_14512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateContract);
export default __webpack_public_path__ + "static/media/create-contract.a03f2cf8e4b2d9e59afb929cf5e935c1.svg";
export { ForwardRef as ReactComponent };